import api from '@/api';

export default {
  namespaced: true,
  state: () => ({
    currentUser: null,
    currentGrade: null,
    isAuthenticated: false,
    isAuthenticating: false,
    role: null
  }),
  mutations: {
    SET_CURRENT_USER(state, user) {
      state.currentUser = user;
    },
    SET_IS_AUTHENTICATED(state, isAuthenticated) {
      state.isAuthenticated = isAuthenticated;
    },
    SET_IS_AUTHENTICATING(state, isAuthenticating) {
      state.isAuthenticating = isAuthenticating;
    },
    SET_CURRENT_GRADE(state, currentGrade){
      state.currentGrade = currentGrade;
    }
  },
  actions: {
    async getCurrentUser(context, uuid) {
      try {
        const response = await api.auth.getCurrentUser(uuid);
        // console.log(response.data.person.id)
        const foundStudent = response.data.roles.find(element => element.role.code === "STUDENT");
        if(foundStudent) {
          // console.log('no es admin')
          // const responseStudent = api.auth.checkStudentLevels(response.data.person.id)
          // console.log(responseStudent)
          this.currentGrade = await api.auth.getCurrentGrade(response.data.person.id);
          console.log('userGrade', this.currentGrade)
          localStorage.setItem('userGrade', (this.currentGrade.data.academicGrade.id));
          localStorage.setItem('essentias', (this.currentGrade.data.essentials))
        }
        context.commit('SET_CURRENT_GRADE', this.currentGrade);
        context.commit('SET_CURRENT_USER', response.data);
        context.commit('SET_IS_AUTHENTICATED', true);
      } catch (error) {
        console.log(error);
        throw error;
      }
    },

    removeCurrentUser(context) {
      context.commit('SET_CURRENT_USER', null);
      context.commit('SET_IS_AUTHENTICATED', false);
    },

    setIsAuthenticating(context, isAuthenticating) {
      context.commit('SET_IS_AUTHENTICATING', isAuthenticating);
    },
  },
};
